import { render, staticRenderFns } from "./BookingFormAdmin.vue?vue&type=template&id=2b47bb60&scoped=true&"
import script from "./BookingFormAdmin.vue?vue&type=script&lang=ts&"
export * from "./BookingFormAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./BookingFormAdmin.vue?vue&type=style&index=0&id=2b47bb60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47bb60",
  null
  
)

export default component.exports